import styled from "styled-components";
import { PageBox } from "../../../../../styles/page";

export const MobileMemberWrapper = styled.div`
  padding: 59px 16px 100px;
  height: 100dvh;
  box-sizing: border-box;
  overflow-y: auto;
`;

export const MobileMemberSearchWrapper = styled(PageBox)`
  border: 0.71px solid #d9d9d9;
  border-radius: 8px;
  padding: 20px 10px;
  width: 100%;
  height: 237px;
  position: relative;
`;

export const MobileMemberSearchInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  > .warning {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 11px;
    text-align: right;
    color: #ff0000;
  }

  > input {
    width: 100%;
    height: 36px;
    padding: 10px 15px;
    border-radius: 15px;
    box-sizing: border-box;
    border: 1px solid #bebebe;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
  }

  > input:focus {
    border-color: rgb(112, 112, 112);
    outline: none;
  }
`;

export const MobileMemberSearchResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  > .box {
    width: 100%;
    height: 36px;
    padding: 10px 15px;
    border-radius: 15px;
    box-sizing: border-box;
    border: 1px solid #bebebe;
    background: #ecf0f3;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
  }
`;

export const MobileMemberSearchButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 32px);
  position: absolute;
  bottom: 20px;
  left: 16px;

  > .cancel-button {
    color: #6436e7;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    align-items: center;
    width: 120px;
    cursor: pointer;
    height: 36px;
    padding: 10px 15px;
    box-sizing: border-box;
  }
`;

export const MobileMemberSearchButton = styled.div<{ isGray: boolean }>`
  height: 36px;
  flex: 1;
  box-sizing: border-box;
  border-radius: 15px;
  background: ${(p) => (p.isGray ? "#bebebe" : "#6436e7")};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  align-items: center;
  margin-top: 5px;
  padding: 10px 15px;
  cursor: pointer;
`;

export const MobileMemberListWrapper = styled(PageBox)`
  margin-top: 20px;
  width: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
  border: 0.71px solid #d9d9d9;
  border-radius: 8px;

  > .bar {
    border: 1.54px solid #d9d9d9;
    margin: 20px 0;
  }
`;

export const MobileMemberListSearch = styled.div`
  height: 36px;
  margin-top: 20px;
  border-radius: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  gap: 10px;
  border: 1px solid #bebebe;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > input {
    border: none;
    outline: none;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
  }
`;

export const MobileMemberTableWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    width: 30%;
  }

  .date {
    width: 25%;
  }

  .count {
    width: 13%;
  }
`;

export const MobileMemberTableHeader = styled.div`
  display: flex;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 11px;
  text-align: center;
  padding: 3px 10px;
  justify-content: space-between;
`;

export const MobileMemberTableBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 310px;
`;

export const MobileMemberTableBodyItem = styled.div`
  display: flex;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 11px;
  text-align: center;
  height: 40px;
  border-radius: 8px;
  padding: 3px 10px;
  box-sizing: border-box;
  background: #ecf0f3;
  align-items: center;
  justify-content: space-between;

  > .name {
    background: #373636;
    color: #fff;
    height: 24px;
    border-radius: 5px;
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-left: 10px;
    box-sizing: border-box;
    min-width: 90px;
  }
`;
